<nz-modal [(nzVisible)]="isVisible" nzTitle="View Customer" (nzOnCancel)="handleCancel()"  footer={null}>
  <ng-container *nzModalContent>
    <div>
      <section id="customerDetails" class="mt-5">
        <div>
          <div class="mt-5 grid md:grid-cols-1  gap-8">

            <div>
              <div class="sub-section" style="height: 100%">
                <div class="item-row">
                  <p class="subject-name">Full Name</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.fullName ? (customerData?.renterDetails?.fullName) : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Country</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.homeCountry ? (customerData?.renterDetails?.homeCountry) : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Contact Number</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.contactNo ? (customerData?.renterDetails?.contactNo) : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Date of Birth</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.dob ? (customerData?.renterDetails?.dob | date:'yyyy-MM-dd | h:mm a') : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Birth City</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.birthCity ? (customerData?.renterDetails?.birthCity) : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Birth Country</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.birthCountry ? (customerData?.renterDetails?.birthCountry) : '-' }}</p>
                </div>
              </div>
            </div>

            <div>
              <div class="sub-section" style="height: 100%">
                <div class="item-row">
                  <p class="subject-name">Home Address</p>
                  <p
                    class="subject-data">{{ customerData?.renterDetails?.homeAddress ? (customerData?.renterDetails?.homeAddress) : '-' }}</p>
                </div>

              </div>
            </div>

            <div>

            </div>

          </div>
        </div>
      </section>

      <section id="passportDetails" class="mt-5">
        <div>
          <div class="flex justify-between gap-2 flex-col md:flex-row">
            <h5 class="text-primary">Passport / Licence Details</h5>
          </div>
          <div class="mt-5 grid md:grid-cols-1  gap-8">

            <div>
              <div class="sub-section" style="height: 100%">
                <h5 class="mb-2">Passport</h5>
                <div class="item-row">
                  <p class="subject-name">Passport Number</p>
                  <p
                    class="subject-data">{{ customerData?.passportLicenceDetails?.passportNo ? (customerData?.passportLicenceDetails?.passportNo) : '-' }}</p>

                </div>
                <div class="item-row">
                  <p class="subject-name">Passport Issued Date</p>
                  <p
                    class="subject-data">{{ customerData?.passportLicenceDetails?.issueDatePass ? (customerData?.passportLicenceDetails?.issueDatePass | date:'yyyy-MM-dd') : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Passport Expiry Date</p>
                  <p
                    class="subject-data">{{ customerData?.passportLicenceDetails?.expiryDatePass ? (customerData?.passportLicenceDetails?.expiryDatePass | date:'yyyy-MM-dd') : '-' }}</p>
                </div>
              </div>
            </div>

            <div>
              <div class="sub-section" style="height: 100%">
                <h5 class="mb-2">Licence</h5>
                <div class="item-row">
                  <p class="subject-name">Licence Number</p>
                  <p
                    class="subject-data">{{ customerData?.passportLicenceDetails?.drivingLicenceNo ? customerData?.passportLicenceDetails?.drivingLicenceNo : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Licence Issued Date</p>
                  <p
                    class="subject-data">{{ customerData?.passportLicenceDetails?.issueDateLicence ? (customerData?.passportLicenceDetails?.issueDateLicence | date:'yyyy-MM-dd') : '-' }}</p>
                </div>
                <div class="item-row">
                  <p class="subject-name">Licence Expiry Date</p>
                  <p
                    class="subject-data">{{ customerData?.passportLicenceDetails?.expiryDateLicence ? (customerData?.passportLicenceDetails?.expiryDateLicence | date:'yyyy-MM-dd') : '-' }}</p>
                </div>
              </div>
            </div>

            <div>
              <div class="sub-section" style="height: 100%">
                <div class="mt-2" *ngFor="let item of customerData?.passportLicenceFiles">
                  <a [href]="item.url" class="flex" target="_blank">
                    <img src="assets/img/file.png" height="20" width="20" alt="file">
                    <p class="pl-3">{{item.name}}</p>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>

    <!--    <div [ngClass]="loading ? 'block' : 'hidden'">-->
    <!--      <app-single-view-skeleton-template [typeName]="'single-view'"></app-single-view-skeleton-template>-->
    <!--    </div>-->

  </ng-container>
  <ng-container *nzModalFooter>
  </ng-container>
</nz-modal>
